import React, { useMemo } from 'react';
import classnames from 'classnames';
import { CardGridProps } from './types';
import styles from './index.module.scss';

function CardGrid({
  children,
  classNames,
  'data-test-id': dataTestId = 'card-grid',
}: CardGridProps) {
  const childrenArray = React.Children.toArray(children);
  const childCount = childrenArray.length;

  // Determine the layout variant based on number of children
  const layoutVariant = useMemo(() => {
    if (childCount <= 1) return '2'; // Default to 2 columns for single item
    if (childCount <= 8) return String(childCount);
    return '8'; // Default to 8-tile layout for more than 8 items
  }, [childCount]);

  const classes = classnames(
    styles.cardGrid,
    styles[`cardGrid__${layoutVariant}`],
    classNames,
  );

  return (
    <div className={classes} data-test-id={dataTestId}>
      {children}
    </div>
  );
}

export default CardGrid;
